import { render, staticRenderFns } from "./UpdateCustomerInfo.vue?vue&type=template&id=4163cce2&"
import script from "./UpdateCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports